import axios from 'axios'
import React, { useEffect, useState } from 'react'
import validator from 'validator'
import authService from '../../../Components/Login/auth.service'
import '../../../styles/pages/MenuDireito/modal/modalPessoa.css'

export default function Modal({ setOpenModal, modalInfo }) {
  var user = authService.getCurrentUser()
  const [funcoes, setFuncao] = useState([])
  const [grupos, setGrupo] = useState([])
  const [modal, setModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [errorPass, setErrorPass] = useState(false)
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/funcao/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setFuncao(response.data)
      })
  }, [])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/grupoUsuario/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setGrupo(response.data)
      })
  }, [])

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdPessoa: modalInfo.IdPessoa,
    IdEmpresa: modalInfo.IdEmpresa,
    IdFuncao: modalInfo.IdFuncao,
    IdGrupoUsuario: modalInfo.IdGrupoUsuario,
    pesNome: modalInfo.pesNome,
    pesFoto: modalInfo.pesFoto,
    pesEmail: modalInfo.pesEmail,
    pesSenha: '',
    pesTelefone: modalInfo.pesTelefone,
    pesCelular: modalInfo.pesCelular,
    pesEndereco: modalInfo.pesEndereco,
    pesAcessoWeb: modalInfo.pesAcessoWeb,
    pesAcessoApp: modalInfo.pesAcessoApp,
    pesIdioma: modalInfo.pesIdioma,
    pesStatus: modalInfo.pesStatus,
    pesObservacoes: modalInfo.pesObservacoes,
    pesAlteradoPor: user[0].pesEmail,
    pesAlteradoEm: newDate
  })

  function handleInputChange(event) {
    if (
      event.target.name === 'pesAcessoWeb' ||
      event.target.name === 'pesAcessoApp' ||
      event.target.name === 'pesStatus'
    ) {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      if (event.target.name === 'pesSenha') {
        if (
          validator.isStrongPassword(event.target.value, {
            minLength: 8,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1
          })
        ) {
          setErrorMessage('')
          setErrorPass(false)
          if (event.target.value !== campos.confPesSenha) {
            setErrorPass(true)
            setErrorMessage('A confirmação da senha está incorreta')
          } else {
            setErrorMessage('')
            setErrorPass(false)
          }
        } else {
          setErrorPass(true)
          setErrorMessage(
            'A senha não é segura o bastante, a senha deve conter 1 caracter especial, uma letra maiúscula e um número!'
          )
        }
      }
      if (event.target.name === 'confPesSenha') {
        if (event.target.value !== campos.pesSenha) {
          setErrorPass(true)
          setErrorMessage('A confirmação da senha está incorreta')
        } else {
          setErrorMessage('')
          setErrorPass(false)
        }
      }
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
    console.log(campos)
  }

  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .put(
        process.env.REACT_APP_API_URL + '/api/v1/pessoa/' + campos.IdPessoa,
        campos
      )
      .then(response => {
        if (response.status === 200) {
          window.location.reload()
        } else {
          alert(response.data.message)
        }
      })
  }
  return (
    <>
      <div
        onClick={() => {
          setOpenModal(false)
        }}
        className="overlay"
      ></div>
      <div className="modalPadraoPessoa-content">
        <div className="cxTituloPadrao">
          <h1>
            Editar Pessoa
            <hr className="hrTitleModal" />
          </h1>
          <button
            onClick={() => {
              setOpenModal(false)
            }}
          >
            X
          </button>
        </div>
        <form onSubmit={handleFormSubmit}>
          <label>Nome</label>
          <input
            placeholder="Nome"
            type="text"
            id="fname"
            defaultValue={campos.pesNome}
            name="pesNome"
            onChange={handleInputChange}
          />
          <div className="lineModal">
            <label>Selecione a função:</label>
            <label>Selecione o Idioma:</label>
          </div>

          <div className="lineModal">
            <select
              name="IdFuncao"
              type="text"
              defaultValue={campos.IdFuncao?.toString()}
              id="fcontexto"
              onChange={handleInputChange}
            >
              <option value="0">Selecione uma Função</option>
              {funcoes
                .filter(val => {
                  if (val.fncStatus === 1) {
                    return val
                  }
                })
                .map(funcao => (
                  <option
                    value={funcao.IdFuncao}
                    selected={funcao.IdFuncao === campos.IdFuncao}
                  >
                    {funcao.fncDescricao}
                  </option>
                ))}
            </select>
            <select
              name="pesIdioma"
              type="text"
              defaultValue={campos.pesIdioma}
              id="fcontexto"
              onChange={handleInputChange}
            >
              <option value="">Selecione o Idioma</option>
              <option value="PORTUGUES" selected={campos.pesIdioma === 'PORTUGUES'} >Português</option>
              <option value="INGLES" selected={campos.pesIdioma === 'INGLES'}>Inglês</option>
              <option value="ESPANHOL" selected={campos.pesIdioma === 'ESPANHOL'}>Espanhol</option>
            </select>
          </div>
          <label>Digite o Email:</label>
          <input
            type="text"
            defaultValue={campos.pesEmail}
            id="mail"
            name="pesEmail"
            onChange={handleInputChange}
          />
          <div className="lineModal">
            <label>Digite o Telefone:</label>
            <label>Digite o Celular:</label>
          </div>
          <div className="lineModal">
            <input
              type="text"
              defaultValue={campos.pesTelefone}
              id="fname"
              name="pesTelefone"
              onChange={handleInputChange}
            />
            <input
              type="text"
              defaultValue={campos.pesCelular}
              id="fname"
              name="pesCelular"
              onChange={handleInputChange}
            />
          </div>
          <div className="lineModal">
            <label>Senha:</label>
            <label>Confirmar Senha:</label>
            <label>Selecione um grupo:</label>
          </div>
          <div className="lineModal">
            <input
              placeholder="Senha"
              type="password"
              defaultValue={campos.pesSenha}
              id="fname"
              name="pesSenha"
              onChange={handleInputChange}
            />
            <input
              placeholder="Confirmar Senha"
              type="password"
              id="fname"
              name="confPesSenha"
              onChange={handleInputChange}
            />
            <select
              name="IdGrupoUsuario"
              type="text"
              defaultValue={campos.IdGrupoUsuario}
              id="fcontexto"
              onChange={handleInputChange}
            >
              <option value="0">Selecione um grupo</option>
              {grupos
                .filter(val => {
                  if (val.gruStatus === 1) {
                    return val
                  }
                })
                .map(grupo => (
                  <option
                    value={grupo.IdGrupoUsuario}
                    selected={grupo.IdGrupoUsuario === campos.IdGrupoUsuario}
                  >
                    {grupo.gruDescricao}
                  </option>
                ))}
            </select>
          </div>
          <input
            hidden
            className="fcadastroPessoa8"
            placeholder="Endereço"
            type="text"
            defaultValue={campos.pesEndereco}
            id="fname"
            name="pesEndereco"
            onChange={handleInputChange}
          />
          <label>Observações:</label>
          <textarea
            placeholder="Observações"
            type="text"
            defaultValue={campos.pesObservacoes}
            id="fname"
            name="pesObservacoes"
            row="none"
            maxLength="500"
            onChange={handleInputChange}
          />

          {errorPass === true ? (
            <span className="Alert">{errorMessage}</span>
          ) : (
            <div></div>
          )}

          <div className="caixaSalvarPadrao">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '70px'
              }}
              className="InputAuthorization4"
            >
              <label>
                <input
                  name="pesAcessoApp"
                  type="checkbox"
                  defaultChecked={!!campos.pesAcessoApp}
                  onChange={handleInputChange}
                />

                <span>Acesso ao APP</span>
              </label>
              <label>
                <input
                  name="pesAcessoWeb"
                  type="checkbox"
                  defaultChecked={!!campos.pesAcessoWeb}
                  onChange={handleInputChange}
                />
                <span>Acesso Web</span>
              </label>
              <label>
                <input
                  name="pesStatus"
                  type="checkbox"
                  defaultChecked={!!campos.pesStatus}
                  onChange={handleInputChange}
                />
                <span>Status</span>
              </label>
            </div>

            <button type="submit" disabled={errorPass}>
              Salvar Registro
            </button>
          </div>
        </form>
      </div>
    </>
  )
}
